import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import color from "../../../components/utils/Colors";

interface OverviewTabProps {
  course?: any;
}

const OverviewTab: React.FC<OverviewTabProps> = ({ course }) => {
  const courseDetails = [
    {
      title: "Course no",
      details: [
        `Level: ${course?.level || "Beginner"}`,
        `Language: ${course?.language || "English"}`,
        `Duration: ${course?.timeline || "N/A"}`,
      ],
    },
    {
      title: "Description",
      details: [
        course?.description || "No description provided",
        `Who can join: ${course?.whoCanJoin || "Anyone"}`,
      ],
    },
    {
      title: "What you will learn",
      details:
        course?.learningObjectives && course.learningObjectives.length > 0
          ? course.learningObjectives
          : ["Not specified"],
    },
    {
      title: "Teacher Name",
      details: [course?.teachersName || "Unknown"],
    },
    {
      title: "Course available for",
      details: ["Android", "iOS", "Web"],
    },
  ];

  return (
    <div>
      <Box sx={{ padding: "30px 0px" }}>
        <Typography
          sx={{
            color: color.textColor,
            fontWeight: "600",
            fontSize: { xs: "18px", sm: "20px", md: "24px" },
            textDecoration: "underline",
            padding: 0,
          }}
        >
          About this course
        </Typography>
      </Box>

      <Box sx={{ padding: { xs: 2, sm: 2 } }}>
        <Grid
          container
          spacing={2}
          sx={{
            border: "2px solid",
            borderRadius: "12px",
            borderColor: color.borderColor,
            padding: 0,
          }}
        >
          {courseDetails.map((section, index) => (
            <Grid
              container
              item
              xs={12}
              key={index}
              sx={{
                borderBottom:
                  index < courseDetails.length - 1 ? "1px solid gray" : "none",
                paddingBottom: 2,
                minHeight: { xs: "auto", sm: "100px" },
                paddingTop: 2,
              }}
            >
              <Grid
                item
                xs={12}
                sm={4}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  pl: 2,
                  pr: 2,
                  pb: 1,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ color: "rgba(41, 8, 84, 1)", fontWeight: "600" }}
                >
                  {section.title}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={8}
                sx={{
                  display: "flex",
                  pr: 1,
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  pl: { xs: 2, sm: 0 },
                }}
              >
                {section.details.length > 0 && (
                  <Typography
                    variant="body1"
                    sx={{ color: "rgba(41, 8, 84, 1)", fontWeight: "400" }}
                  >
                    {section.details.map((detail: any, idx: any) => (
                      <React.Fragment key={idx}>
                        • {detail}
                        <br />
                      </React.Fragment>
                    ))}
                  </Typography>
                )}
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Box>
    </div>
  );
};

export default OverviewTab;
